import React from "react";
import styled from "styled-components";
import ContentLoader from "react-content-loader";

const StyledActivityContentLoader = styled(ContentLoader)`
  height: 180px;
  width: 436px;
`;

export const ActivityContentLoader = () => (
  <StyledActivityContentLoader height={180} width={436}>
    <path d="M71.25 10H68.75V50H71.25V10Z" fill="black" />
    <path d="M406.25 16H85.25V26H406.25V16Z" fill="black" />
    <path
      d="M208.25 36.0254H85.25V46.0254H208.25V36.0254Z"
      fill="black"
      stroke="black"
      strokeWidth="1.5"
    />
    <path d="M71.25 65H68.75V105H71.25V65Z" fill="black" />
    <path d="M406.25 71H85.25V81H406.25V71Z" fill="black" />
    <path
      d="M208.25 91.0254H85.25V101.025H208.25V91.0254Z"
      fill="black"
      stroke="black"
      strokeWidth="1.5"
    />
    <path d="M71.25 122H68.75V162H71.25V122Z" fill="black" />
    <path d="M406.25 128H85.25V138H406.25V128Z" fill="black" />
    <path
      d="M208.25 148.025H85.25V158.025H208.25V148.025Z"
      fill="black"
      stroke="black"
      strokeWidth="1.5"
    />
  </StyledActivityContentLoader>
);
